import axios from 'axios';
import constants from '../../const.js';
const { GARMENT_API } = constants;

/**
 * ACTION TYPES
 */
const GARMENT_REQUEST = "GARMENT_REQUEST";
const GARMENT_SUCCESS = "GARMENT_SUCCESS";
const GARMENT_FAILURE = "GARMENT_FAILURE";

const GET_GARMENTS_REQUEST = "GET_GARMENTS_REQUEST";
const GET_GARMENTS_SUCCESS = "GET_GARMENTS_SUCCESS";
const GET_GARMENTS_FAILURE = "GET_GARMENTS_FAILURE";

const GET_GARMENT_BY_ACTOR_REQUEST = "GET_GARMENT_BY_ACTOR_REQUEST";
const GET_GARMENT_BY_ACTOR_SUCCESS = "GET_GARMENT_BY_ACTOR_SUCCESS";
const GET_GARMENT_BY_ACTOR_FAILURE = "GET_GARMENT_BY_ACTOR_FAILURE";

const CREATE_GARMENT_REQUEST = "CREATE_GARMENT_REQUEST";
const CREATE_GARMENT_SUCCESS = "CREATE_GARMENT_SUCCESS";
const CREATE_GARMENT_FAILURE = "CREATE_GARMENT_FAILURE";

const UPDATE_GARMENT_REQUEST = "UPDATE_GARMENT_REQUEST";
const UPDATE_GARMENT_SUCCESS = "UPDATE_GARMENT_SUCCESS";
const UPDATE_GARMENT_FAILURE = "UPDATE_GARMENT_FAILURE";

const DELETE_GARMENT_REQUEST = "DELETE_GARMENT_REQUEST";
const DELETE_GARMENT_SUCCESS = "DELETE_GARMENT_SUCCESS";
const DELETE_GARMENT_FAILURE = "DELETE_GARMENT_FAILURE";

const GET_GARMENT_ATTRIBUTES_REQUEST = "GET_GARMENT_ATTRIBUTES_REQUEST";
const GET_GARMENT_ATTRIBUTES_SUCCESS = "GET_GARMENT_ATTRIBUTES_SUCCESS";
const GET_GARMENT_ATTRIBUTES_FAILURE = "GET_GARMENT_ATTRIBUTES_FAILURE";

const GET_SCENE_GARMENTS_REQUEST = "GET_SCENE_GARMENTS_REQUEST";
const GET_SCENE_GARMENTS_SUCCESS = "GET_SCENE_GARMENTS_SUCCESS";
const GET_SCENE_GARMENTS_FAILURE = "GET_SCENE_GARMENTS_FAILURE";

/**
 * ACTION CREATORS
 */
const garmentRequest = () => ({
    type: GARMENT_REQUEST
});

const garmentSuccess = (garment) => ({
    type: GARMENT_SUCCESS,
    garment
});

const garmentFailure = (error) => ({
    type: GARMENT_FAILURE,
    error
});

const getGarmentsRequest = () => ({
    type: GET_GARMENTS_REQUEST
});

const getGarmentsSuccess = (garments) => ({
    type: GET_GARMENTS_SUCCESS,
    garments
});

const getGarmentsFailure = (error) => ({
    type: GET_GARMENTS_FAILURE,
    error
});

const getGarmentByActorRequest = () => ({
    type: GET_GARMENT_BY_ACTOR_REQUEST
});

const getGarmentByActorSuccess = (garments) => ({
    type: GET_GARMENT_BY_ACTOR_SUCCESS,
    garments
});

const getGarmentByActorFailure = (error) => ({
    type: GET_GARMENT_BY_ACTOR_FAILURE,
    error
});

const createGarmentRequest = () => ({
    type: CREATE_GARMENT_REQUEST
});

const createGarmentSuccess = (garment) => ({
    type: CREATE_GARMENT_SUCCESS,
    garment
});

const createGarmentFailure = (error) => ({
    type: CREATE_GARMENT_FAILURE,
    error
});

const updateGarmentRequest = () => ({
    type: UPDATE_GARMENT_REQUEST
});

const updateGarmentSuccess = (garment) => ({
    type: UPDATE_GARMENT_SUCCESS,
    garment
});

const updateGarmentFailure = (error) => ({
    type: UPDATE_GARMENT_FAILURE,
    error
});

const deleteGarmentRequest = () => ({
    type: DELETE_GARMENT_REQUEST
});

const deleteGarmentSuccess = (garmentId) => ({
    type: DELETE_GARMENT_SUCCESS,
    garmentId
});

const deleteGarmentFailure = (error) => ({
    type: DELETE_GARMENT_FAILURE,
    error
});

const getGarmentAttributesRequest = () => ({
    type: GET_GARMENT_ATTRIBUTES_REQUEST
});

const getGarmentAttributesSuccess = (attributes) => ({
    type: GET_GARMENT_ATTRIBUTES_SUCCESS,
    attributes
});

const getGarmentAttributesFailure = (error) => ({
    type: GET_GARMENT_ATTRIBUTES_FAILURE,
    error
});

const getSceneGarmentsRequest = () => ({
    type: GET_SCENE_GARMENTS_REQUEST
});

const getSceneGarmentsSuccess = (garments) => ({
    type: GET_SCENE_GARMENTS_SUCCESS,
    garments
});

const getSceneGarmentsFailure = (error) => ({
    type: GET_SCENE_GARMENTS_FAILURE,
    error
});

/**
 * THUNK ACTIONS
 */

/**
 * Get all garments (supports server-side search/filter/pagination)
 */
export const getAllGarments = ({ search, actor_id, category_id, page, limit, sort_by, sort_order } = {}) => {
    return dispatch => {
        dispatch(getGarmentsRequest());
        const params = new URLSearchParams();
        if (search) params.set('search', search);
        if (actor_id) params.set('actor_id', actor_id);
        if (category_id) params.set('category_id', category_id);
        if (page) params.set('page', page);
        if (limit) params.set('limit', limit);
        if (sort_by) params.set('sort_by', sort_by);
        if (sort_order) params.set('sort_order', sort_order);
        const qs = params.toString();
        return axios.get(`${GARMENT_API.GARMENT_LIST_URL}${qs ? '?' + qs : ''}`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                dispatch(getGarmentsSuccess(res.data.garments || []));
                return res.data;
            })
            .catch(error => {
                console.log('Error getting garments:', error);
                dispatch(getGarmentsFailure(error.message));
                throw error;
            });
    };
};

/**
 * Get garments by actor ID
 */
export const getGarmentsByActorId = (actorId) => {
    return dispatch => {
        dispatch(getGarmentByActorRequest());
        return axios.get(`${GARMENT_API.GARMENT_BY_ACTOR_URL}/${actorId}`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                dispatch(getGarmentByActorSuccess(res.data.garments || []));
                return res.data;
            })
            .catch(error => {
                console.log('Error getting garments by actor:', error);
                dispatch(getGarmentByActorFailure(error.message));
                throw error;
            });
    };
};

/**
 * Get single garment by ID
 */
export const getGarmentById = (id) => {
    return dispatch => {
        dispatch(garmentRequest());
        return axios.get(`${GARMENT_API.GARMENT_DETAIL_URL}/${id}`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                dispatch(garmentSuccess(res.data.garment));
                return res.data;
            })
            .catch(error => {
                console.log('Error getting garment:', error);
                dispatch(garmentFailure(error.message));
                throw error;
            });
    };
};

/**
 * Create new garment
 */
export const createGarment = (garmentData) => {
    return dispatch => {
        dispatch(createGarmentRequest());
        return axios.post(GARMENT_API.GARMENT_LIST_URL, garmentData, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                dispatch(createGarmentSuccess(res.data.garment));
                return res.data;
            })
            .catch(error => {
                console.log('Error creating garment:', error);
                dispatch(createGarmentFailure(error.message));
                throw error;
            });
    };
};

/**
 * Update garment
 */
export const updateGarment = (id, garmentData) => {
    return dispatch => {
        dispatch(updateGarmentRequest());
        return axios.put(`${GARMENT_API.GARMENT_DETAIL_URL}/${id}`, garmentData, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                dispatch(updateGarmentSuccess(res.data.garment));
                return res.data;
            })
            .catch(error => {
                console.log('Error updating garment:', error);
                dispatch(updateGarmentFailure(error.message));
                throw error;
            });
    };
};

/**
 * Delete garment images from content API
 */
export const deleteGarmentImages = (garmentId, actorId) => {
    const token = localStorage.getItem('token')?.replace('Bearer ', '') || '';
    return axios.delete(`${constants.CONTENT_DOMAIN}upload/garment/${garmentId}/actor/${actorId}?token=${token}`)
        .then(res => res.data)
        .catch(error => {
            console.warn('Error deleting garment images:', error.message);
        });
};

/**
 * Delete garment
 */
export const deleteGarment = (id, actorId) => {
    return async dispatch => {
        dispatch(deleteGarmentRequest());
        try {
            if (actorId) {
                await deleteGarmentImages(id, actorId);
            }
            const res = await axios.delete(`${GARMENT_API.GARMENT_DETAIL_URL}/${id}`, {
                headers: { 'Authorization': `${localStorage.getItem('token')}` }
            });
            dispatch(deleteGarmentSuccess(id));
            return res.data;
        } catch (error) {
            console.log('Error deleting garment:', error);
            dispatch(deleteGarmentFailure(error.message));
            throw error;
        }
    };
};

/**
 * Get garment attributes (categories, styles, patterns, etc.)
 */
export const getGarmentAttributes = () => {
    return dispatch => {
        dispatch(getGarmentAttributesRequest());
        return Promise.all([
            axios.get(GARMENT_API.GARMENT_CATEGORIES_URL, {
                headers: { 'Authorization': `${localStorage.getItem('token')}` }
            }),
            axios.get(GARMENT_API.GARMENT_STYLES_URL, {
                headers: { 'Authorization': `${localStorage.getItem('token')}` }
            }),
            axios.get(GARMENT_API.GARMENT_PATTERNS_URL, {
                headers: { 'Authorization': `${localStorage.getItem('token')}` }
            }),
            axios.get(GARMENT_API.GARMENT_TEXTURES_URL, {
                headers: { 'Authorization': `${localStorage.getItem('token')}` }
            }),
            axios.get(GARMENT_API.GARMENT_MATERIALS_URL, {
                headers: { 'Authorization': `${localStorage.getItem('token')}` }
            })
        ])
            .then(responses => {
                const attributes = {
                    categories: responses[0].data.categories || [],
                    styles: responses[1].data.styles || [],
                    patterns: responses[2].data.patterns || [],
                    textures: responses[3].data.textures || [],
                    materials: responses[4].data.materials || []
                };
                dispatch(getGarmentAttributesSuccess(attributes));
                return attributes;
            })
            .catch(error => {
                console.log('Error getting garment attributes:', error);
                dispatch(getGarmentAttributesFailure(error.message));
                throw error;
            });
    };
};

/**
 * Tag garment to scene
 */
export const tagGarmentToScene = (sceneId, garmentId) => {
    return dispatch => {
        return axios.post(`${GARMENT_API.SCENE_GARMENT_TAG_URL}/${sceneId}/garments/${garmentId}`, {}, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => res.data)
            .catch(error => {
                console.log('Error tagging garment to scene:', error);
                throw error;
            });
    };
};

/**
 * Untag garment from scene
 */
export const untagGarmentFromScene = (sceneId, garmentId) => {
    return dispatch => {
        return axios.delete(`${GARMENT_API.SCENE_GARMENT_TAG_URL}/${sceneId}/garments/${garmentId}`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => res.data)
            .catch(error => {
                console.log('Error untagging garment from scene:', error);
                throw error;
            });
    };
};

/**
 * Tag garment to album
 */
export const tagGarmentToAlbum = (albumId, garmentId) => {
    return dispatch => {
        return axios.post(`${GARMENT_API.ALBUM_GARMENT_TAG_URL}/${albumId}/garments/${garmentId}`, {}, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => res.data)
            .catch(error => {
                console.log('Error tagging garment to album:', error);
                throw error;
            });
    };
};

/**
 * Untag garment from album
 */
export const untagGarmentFromAlbum = (albumId, garmentId) => {
    return dispatch => {
        return axios.delete(`${GARMENT_API.ALBUM_GARMENT_TAG_URL}/${albumId}/garments/${garmentId}`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => res.data)
            .catch(error => {
                console.log('Error untagging garment from album:', error);
                throw error;
            });
    };
};

/**
 * Get garments for a specific scene
 */
export const getSceneGarments = (sceneId) => {
    return dispatch => {
        dispatch(getSceneGarmentsRequest());
        return axios.get(`${GARMENT_API.SCENE_GARMENT_TAG_URL}/${sceneId}`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                const garments = res.data?.garments || [];
                dispatch(getSceneGarmentsSuccess(garments));
                return res.data;
            })
            .catch(error => {
                console.log('Error getting scene garments:', error);
                dispatch(getSceneGarmentsFailure(error.message));
                throw error;
            });
    };
};

export const getGarmentScenes = (garmentId) => {
    return dispatch => {
        return axios.get(`${GARMENT_API.GARMENT_DETAIL_URL}/${garmentId}/scenes`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => res.data)
            .catch(error => {
                console.log('Error getting garment scenes:', error);
                throw error;
            });
    };
};

/**
 * Get next available garment ID from database
 */
export const getNextGarmentId = () => {
    return dispatch => {
        return axios.get(`${GARMENT_API.GARMENT_LIST_URL}?limit=1&sort_by=id&sort_order=desc`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                const garments = res.data?.garments || [];
                const maxId = garments.length > 0 ? garments[0].id : 0;
                return maxId + 1;
            })
            .catch(error => {
                console.log('Error fetching next garment ID:', error);
                throw error;
            });
    };
};

/**
 * Get image history for a garment
 */
export const getGarmentImageHistory = (garmentId) => {
    return dispatch => {
        return axios.get(`${GARMENT_API.GARMENT_LIST_URL}/${garmentId}/images`, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => {
                return res.data?.images || [];
            })
            .catch(error => {
                console.log('Error fetching garment image history:', error);
                throw error;
            });
    };
};

/**
 * Add image to garment history
 */
export const addImageToHistory = (garmentId, imageUrl, imageType, metadata = {}) => {
    return dispatch => {
        return axios.post(`${GARMENT_API.GARMENT_LIST_URL}/${garmentId}/images`, {
            image_url: imageUrl,
            image_type: imageType,
            file_size: metadata.file_size || null,
            width: metadata.width || null,
            height: metadata.height || null,
            created_by: metadata.created_by || 'admin'
        }, {
            headers: { 'Authorization': `${localStorage.getItem('token')}` }
        })
            .then(res => res.data)
            .catch(error => {
                console.log('Error adding image to history:', error);
                throw error;
            });
    };
};

/**
 * Regenerate flat lay image with custom prompt
 */
export const regenerateFlatLay = (garmentId, actorId, prompt, model, attributes) => {
    return dispatch => {
        const token = localStorage.getItem('token')?.replace('Bearer ', '') || '';
        const body = { prompt };
        if (model && model !== 'auto') body.model = model;
        if (attributes) body.attributes = attributes;
        return axios.post(`${constants.CONTENT_DOMAIN}upload/garment/${garmentId}/actor/${actorId}/regenerate-flatlay?token=${token}`, body)
            .then(res => {
                return res.data;
            })
            .catch(error => {
                console.log('Error regenerating flat lay:', error);
                throw error;
            });
    };
};

export const garmentActions = {
    getAllGarments,
    getGarmentsByActorId,
    getGarmentById,
    createGarment,
    updateGarment,
    deleteGarment,
    deleteGarmentImages,
    getGarmentAttributes,
    tagGarmentToScene,
    untagGarmentFromScene,
    tagGarmentToAlbum,
    untagGarmentFromAlbum,
    getSceneGarments,
    getGarmentScenes,
    getNextGarmentId,
    getGarmentImageHistory,
    addImageToHistory,
    regenerateFlatLay
};
